import AxiosInterceptor from 'api/interceptor';

const staticPage = new AxiosInterceptor();

export default {
  find(inputs = {page: 'about-us'}) {
    inputs.page = inputs.page ? inputs.page : 'about-us';
    return staticPage.get('/site/pages/get?page=' + inputs.page + '&lang=' + inputs.lang);
  },
  get(inputs = {page: 1, limit: 10}) {
    inputs.page = inputs.page ? inputs.page : 1;
    inputs.limit = inputs.limit ? inputs.limit : 10;
    return staticPage.get('/site/pages');
  },
  update(inputs) {
    return staticPage.put('/site/pages/manage', {
      'page': inputs.page,
      'lang_id': inputs.lang_id,
      'title': inputs.title,
      'content': inputs.content
    });
  },
  create(inputs) {
    return staticPage.post('/site/pages/manage', {
      'page': inputs.page,
      'lang_id': inputs.lang_id,
      'title': inputs.title,
      'content': inputs.content
    });
  }
};
